"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessage = exports.useChannel = void 0;
const phoenix_1 = require("phoenix");
const react_1 = require("react");
const SocketContext_1 = require("./SocketContext");
function useChannel(topic, params, onJoin, onSync = null) {
    const { socket } = (0, react_1.useContext)(SocketContext_1.SocketContext);
    const [channel, setChannel] = (0, react_1.useState)(null);
    const onJoinFun = (0, react_1.useRef)(onJoin);
    onJoinFun.current = onJoin;
    const onSyncFun = (0, react_1.useRef)(onSync);
    onSyncFun.current = onSync;
    (0, react_1.useEffect)(() => {
        if (socket === null || topic == null) {
            return;
        }
        if (!socket.channel) {
            // eslint-disable-next-line consistent-return
            return null;
        }
        const ch = socket.channel(topic, params);
        if (onSync) {
            const pres = new phoenix_1.Presence(ch);
            pres.onSync(() => {
                onSyncFun.current(pres);
            });
        }
        ch.join().receive('ok', message => onJoinFun.current(ch, message));
        setChannel(ch);
        // eslint-disable-next-line consistent-return
        return () => {
            ch.leave();
            setChannel(null);
        };
    }, [socket, topic, params]);
    return channel;
}
exports.useChannel = useChannel;
function pushPromise(push) {
    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
        if (!push) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject('no push');
        }
        push.receive('ok', resolve).receive('error', reject);
        // .receive('timeout', reject('timeout'));
    });
}
function sendMessage(channel, event, payload) {
    return pushPromise(channel.push(event, payload));
}
exports.sendMessage = sendMessage;
